import PropTypes from "prop-types";

import { LoadingButton } from "@mui/lab";

import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";
import { ChartOfAccountFormDialog } from "../chart-of-account-form-dialog";

export const AddChartOfAccountFormDialog = ({
  onClose,
  onSubmitted,
  defaultValues,
}) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({ code, name, parentId, type, isActive }) => {
    try {
      await apiClient.post("chart-of-accounts", {
        code,
        name,
        parentId,
        type,
        isActive,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan akun"));

      throw error;
    }
  };

  return (
    <ChartOfAccountFormDialog
      isOpen
      onClose={onClose}
      dialogTitle="Tambah Template Akun"
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <LoadingButton loading={isLoading} variant="contained" type="submit">
          Tambah
        </LoadingButton>
      )}
    />
  );
};

AddChartOfAccountFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  defaultValues: PropTypes.object,
};
